/**
 * Help Center targets for InfoModal "Learn more" links.
 *
 * Each value is `/help/<chapterId>` plus an optional `#<heading anchor>` (see
 * helpAnchors.js). Kept in one place so helpLinks.test.js can check every
 * target still resolves — chapter ids and heading text are both URLs here, and
 * a renamed heading would otherwise leave a link that silently lands on the
 * chapter top.
 */
const HELP_LINKS = {
  // Ask Cadenza
  askCadenza: '/help/ask-cadenza',
  askCadenzaSetup: '/help/ask-cadenza#setting-it-up-company-administrators',

  // Engineering — heaps, kinetics, hydro
  heapImport: '/help/heaps#importing-a-heap',
  kinetics: '/help/kinetics',
  labTests: '/help/lab-tests',
  kineticsFitting: '/help/kinetics-fitting',
  fitModels: '/help/kinetics-fitting#the-candidate-models',
  fitTuning: '/help/kinetics-fitting#tuning-after-the-fit',
  fitResults: '/help/kinetics-fitting#reading-the-results',
  hydrodynamics: '/help/hydrodynamics',
  hydroPhysical: '/help/hydrodynamics#physical-properties',
  hydroHydraulic: '/help/hydrodynamics#hydraulic-properties',
  hydroFlowTransfer: '/help/hydrodynamics#flow-transfer',
  hydroParticleSize: '/help/hydrodynamics#particle-size-emerald-model',
  hydroPrecipitation: '/help/hydrodynamics#precipitation-infiltration',
  hydroDepthRecovery: '/help/hydrodynamics#depth-recovery-factor-optional',

  // Leaching, water balance, running
  leaching: '/help/leaching-climate#the-leaching-page',
  waterBalance: '/help/water-balance-run#the-water-flow-network',
  pondNodes: '/help/water-balance-run#pond-nodes',
  plantNodes: '/help/water-balance-run#processing-plant-nodes',
  conditionalRouting: '/help/routing-code-language#conditional-routing-in-practice',
  overflowRedirects: '/help/routing-code-language#overflow-redirects',
  simulationModels: '/help/water-balance-run#model-selection',
  snapshots: '/help/water-balance-run#snapshots',

  // Analysis
  customExport: '/help/custom-export',
  npv: '/help/npv-cashflow',
  npvValuation: '/help/npv-cashflow#valuing-a-simulation',
  npvCostModel: '/help/npv-cashflow#building-an-open-cost-model',
  ensembles: '/help/ensembles',
  ensembleOverrides: '/help/ensembles#the-overrides',
  closure: '/help/closure',
  reconciliation: '/help/reconciliation',
  asBuilt: '/help/reconciliation#mine-plan-vs-as-built',
  geode: '/help/geode-models',

  // Projects
  projectArchiving: '/help/projects#project-status-archiving-and-deletion',

  // Document control
  documentRegister: '/help/document-register',
  revisionLifecycle: '/help/revisions-approvals#the-revision-lifecycle',
  myApprovals: '/help/revisions-approvals#my-approvals',
  transmittals: '/help/transmittals',
  documentSettings: '/help/doc-settings',
};

export default HELP_LINKS;
